import React from 'react'
import styled from 'styled-components'

import UserList from '../../user-list'
import Loader from '../../loader'

import { useFollowing } from '../../../../data/hooks/profile'
import { useScrollTrigger } from '../../../../data/hooks/interface/scroll-trigger'

type FollowersProps = {
  targetPublicId: string | null
}

const Following: React.FunctionComponent<FollowersProps> = ({ targetPublicId }) => {
    const [{ pending, error, data }, update] = useFollowing(targetPublicId)

    const [_, setScrollable] = useScrollTrigger({
        onBottomReached: () => update(data?.length || 0)
    })

    return (
        <Container ref={r => setScrollable(r)}>
            { data && <UserList users={data} /> }
            { !pending && error && <Text>{error}</Text>}
            { !pending && !error && !data?.length && <Text>The user doesn't follow anybody yet</Text>}
            { pending && <Loader />}
        </Container>
    )
}

const Container = styled.div`
    display: grid;
    align-items: center;

    width: 100%;

    margin-top: -32px;
`

const Text = styled.div``

export default Following